var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nuxt-link',{staticClass:"CompareInfo",attrs:{"to":_vm.localePath({ name: 'compare' })}},[_c('span',{staticClass:"sr-only"},[_vm._v(" "+_vm._s(_vm.$t('CompareInfo.titleScreenReader'))+" ")]),_c('svgicon',{attrs:{"icon":require('@icon/balance.svg?raw')}}),_c('InfoCounter',{attrs:{"count":_vm.compareItemsCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }